import { useSelector } from "react-redux";
import { selectors } from "@shared/store";
import { getAllowedHospitalIds } from "@shared/utils/ACL";
import { useMemo } from "react";

interface AllowedHospitalIdsResult {
  ids: (number | null)[];
  hasAccessToMultipleHospitals: boolean;
  defaultHospitalId: number | null;
}

function useAllowedHospitalIds(): AllowedHospitalIdsResult {
  const user = useSelector(selectors.getUserDetails());

  const ids = useMemo(() => {
    return getAllowedHospitalIds(user);
  }, [user]);

  const hasAccessToMultipleHospitals = useMemo(() => {
    return ids.length > 1 || ids[0] === null;
  }, [ids]);

  const defaultHospitalId = useMemo(() => {
    return ids.length === 1 ? ids[0] : null;
  }, [ids]);

  return { ids, hasAccessToMultipleHospitals, defaultHospitalId };
}

export default useAllowedHospitalIds;
